/**
 *
 * Parts
 *
 */

/*
  Decorator for container to display parts search
*/

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import 'css/components/table.sass';
import { makeSelectEntities } from 'models/selectors';
import {
  makeSelectPageData, makeSelectCurrentRegionId, makeSelectCurrentCartId, makeSelectCurrentDomain, makeSelectIsDealerDomain, makeSelectDomainDealers,
} from 'containers/App/selectors';
import { setPageData, addToCart, getAllRegionData } from 'containers/App/actions';
import { addToPodbor } from 'containers/Parts/actions'
import { formValueSelector } from 'redux-form/immutable';

import injectSaga from 'utils/injectSaga';
import saga from './saga';

function Parts (options) {
  const makeValueSelector = (valueName) => (state) => formValueSelector('parts-form')(state, valueName);

  const mapStateToProps = createStructuredSelector({
    cities: makeSelectEntities('cities'),
    offers: makeSelectEntities('offers'),
    dealers: makeSelectEntities('dealers'),
    items: makeSelectEntities('items'),
    images: makeSelectEntities('images'),
    products: makeSelectEntities('products'),
    regions: makeSelectEntities('regions'),
    pageData: makeSelectPageData('parts'),
    msrps: makeSelectEntities('msrps'),
    regionId: makeSelectCurrentRegionId(),
    formDealerId: makeValueSelector('dealerId'),
    isDealerDomain: makeSelectIsDealerDomain(),
    currentCartId: makeSelectCurrentCartId(),
    currentDomain: makeSelectCurrentDomain(),
    domainDealers: makeSelectDomainDealers(),
  });

  function mapDispatchToProps (dispatch) {
    return {
      setPageData: (name, value) => dispatch(setPageData({ page: 'parts', name, value })),
      addToCart: (payload) => dispatch(addToCart(payload)),
      getAllRegionData: () => dispatch(getAllRegionData()),
      addToPodbor: item => dispatch(addToPodbor(item)),
    };
  }

  function wrapped (Content) {
    class DecoratedParts extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
      constructor(props) {
        super(props)
        this.addToCart = this.addToCart.bind(this);
        this.addToPodbor = this.addToPodbor.bind(this)
      }
      componentDidMount () {
        this.props.setPageData('status', 'initial');
        this.props.getAllRegionData();
      }

      addToPodbor(item) {
        this.props.addToPodbor(item.trim())
        // console.log({item})
      }

      addToCart (productId, dealerId, quantity) {
        // console.log(data)
        return new Promise((resolve, reject) => {
          this.props.addToCart({ data: { productId, dealerId, quantity }, resolve, reject });
        }).catch((err) => { throw err; });
      }

      render () {
        return (
          <Content {...this.props} addToCart={this.addToCart} addToPodbor={this.addToPodbor} />
        );
      }
    }

    Parts.propTypes = {
      // dispatch: PropTypes.func.isRequired,
    };

    const withConnect = connect(mapStateToProps, mapDispatchToProps);

    const withSaga = injectSaga({ key: 'parts', saga });

    return compose(
      withSaga,
      withConnect,
    )(DecoratedParts);
  }
  return wrapped;
}

export default Parts;
